function Result() {
    return ( <h1>
        Result
    </h1> );
}

export default Result;